import React, { useState } from "react";
import parse from "html-react-parser";
import ToogetherInfinite from "../../assets/images/infinite.png";
import ToogetherStage from "../../assets/images/e.png";
import ToogetherFormations from "../../assets/images/ee.png";
import ToogetherMillePas from "../../assets/images/mille_pas.jpg";
import ToogetherFanmDobout from "../../assets/images/fanm_dobout.jpg";
import ToogetherSexisme from "../../assets/images/sexisme.png";
import ToogetherDemainLesFilles from "../../assets/images/demain_les_filles.png";
import { HomePageJoinUsInterface } from "../../interfaces/homePageInterfaces";
import { HashLink } from "react-router-hash-link";
import { scrollWithOffset } from "../../custom-functions/customFunctions";

type NeedToJoinCpntProps = {
  content: HomePageJoinUsInterface | undefined;
};

const NeedToJoinCpnt = ({ content }: NeedToJoinCpntProps) => {
  // const [isFirstList, setIsFirstList] = useState(true);

  // const clickOnArrow = () => {
  //   setIsFirstList(!isFirstList);
  // };

  return (
    <article className="need-to-join-article" id="agir">
      <section className="ntja-section">
        <div className="ntjas-text">
          {/* <h2 className='njast-title'>{content?.title}</h2> */}
          <h2 className="njast-title">Avec Toogether, agissez&nbsp;pour l’égalité</h2>
          <div className="njast-text">
            {content ? parse(content.text || "") : ""}
            <HashLink to="/#nous-contacter" scroll={(el) => scrollWithOffset(el, 120)} className="access-button">
              Nous contacter
            </HashLink>
          </div>
        </div>
        <h3 className="ntjas-title">Nos ateliers de sensibilisation</h3>
        <h4 className="ntjas-subtitle">3 heures - mixte &amp; tout public - 8 à 24 personnes</h4>
        <div className="ntjas-wrapper">
          <div className="flip-button">
            <div className="ntjasw-coloured-card third flip-button__inner">
              {/* <div className="ntjasw-arrow">
              <i
                data-eva="arrow-forward-outline"
                data-eva-fill="#FFF"
                data-eva-height="30"
                data-eva-width="30"
              ></i>
            </div> */}
              <div className="flip-button__face flip-button__face--front">
                <h3 className="ntjaswcc-title">FANM DOBOUT</h3>
                <p className="ntjaswcc-intro">
                  Notre atelier <span className="bold">signature</span>
                </p>
                <div className="ntjaswcc-list-image-wrapper">
                  <div className="ntjaswccliw-list-wrapper">
                    <ul className="ntjaswccliwlw-list">
                      <li className="ntjaswccliwlwl-item">Le jeu qui célèbre le matrimoine&nbsp;réunionnais</li>
                      <li className="ntjaswccliwlwl-item">Sensibiliser aux inégalités de genre</li>
                      <li className="ntjaswccliwlwl-item">Témoignage d'une Fanm Dobout</li>
                      <li className="ntjaswccliwlwl-item">Création d'une fresque collective</li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="flip-button__face flip-button__face--back">
                <div className="ntjaswcc-list-image-wrapper">
                  <HashLink to="/#nous-contacter" scroll={(el) => scrollWithOffset(el, 120)}>
                    <img className="ntjaswccliwl-image" src={ToogetherFanmDobout} alt="" />
                  </HashLink>
                </div>
              </div>
            </div>
          </div>
          <div className="flip-button">
            <div className="ntjasw-coloured-card third flip-button__inner">
              {/* <div className="ntjasw-arrow">
              <i
                data-eva="arrow-forward-outline"
                data-eva-fill="#FFF"
                data-eva-height="30"
                data-eva-width="30"
              ></i>
            </div> */}
              <div className="flip-button__face flip-button__face--front">
                <h3 className="ntjaswcc-title">SEXISME, C'EST NON</h3>
                <p className="ntjaswcc-intro">
                  Notre atelier <span className="bold">coup de poing</span>
                </p>
                <div className="ntjaswcc-list-image-wrapper">
                  <div className="ntjaswccliw-list-wrapper">
                    <ul className="ntjaswccliwlw-list">
                      <li className="ntjaswccliwlwl-item">Le jeu qui éveille les consciences</li>
                      <li className="ntjaswccliwlwl-item">Prendre conscience / Comprendre / Agir</li>
                      <li className="ntjaswccliwlwl-item">Pistes d'action pour l'entreprise</li>
                      <li className="ntjaswccliwlwl-item">Création d'un réseau de Sentinelles</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="flip-button__face flip-button__face--back">
                <div className="ntjaswcc-list-image-wrapper">
                  <HashLink to="/#nous-contacter" scroll={(el) => scrollWithOffset(el, 120)}>
                    <img className="ntjaswccliwl-image" src={ToogetherSexisme} alt="" />
                  </HashLink>
                </div>
              </div>
            </div>
          </div>
          <div className="flip-button">
            <div className="ntjasw-coloured-card third flip-button__inner">
              {/* <div className="ntjasw-arrow">
              <i
                data-eva="arrow-forward-outline"
                data-eva-fill="#FFF"
                data-eva-height="30"
                data-eva-width="30"
              ></i>
            </div> */}
              <div className="flip-button__face flip-button__face--front">
                <h3 className="ntjaswcc-title">JEU DES 1000 PAS</h3>
                <p className="ntjaswcc-intro">
                  Notre atelier en <span className="bold">exclusivité</span> avec Bejoue
                </p>
                <div className="ntjaswcc-list-image-wrapper">
                  <div className="ntjaswccliw-list-wrapper">
                    <ul className="ntjaswccliwlw-list">
                      <li className="ntjaswccliwlwl-item">Le jeu de challenge par équipes</li>
                      <li className="ntjaswccliwlwl-item">Comprendre les inégalités de carrière</li>
                      <li className="ntjaswccliwlwl-item">Feuille de route pour l'entreprise</li>
                      <li className="ntjaswccliwlwl-item">Création d'une fresque collective</li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="flip-button__face flip-button__face--back">
                <div className="ntjaswcc-list-image-wrapper">
                  <a href="https://www.linkedin.com/feed/update/urn:li:activity:7293193874133397506" target="_blank">
                    <img className="ntjaswccliwl-image" src={ToogetherMillePas} alt="" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <h3 className="ntjas-title">Nos actions d'impact social</h3>
        <div className="ntjas-wrapper">
          <div className="ntjasw-coloured-card second flip-button__inner">
            {/* <div className="ntjasw-arrow">
              <i
                data-eva="arrow-forward-outline"
                data-eva-fill="#FFF"
                data-eva-height="30"
                data-eva-width="30"
              ></i>
            </div> */}
            <h3 className="ntjaswcc-title">DEMAIN LES FILLES</h3>
            <p className="ntjaswcc-intro">
              En partenariat avec <a href="https://ensemble-en-stage.com/" target="_blank">Ensemble en stage</a>, l'ONG de référence pour l'égalité des chances à La Réunion
            </p>
            <div className="ntjaswcc-list-image-wrapper">
              <a href="https://ensemble-en-stage.com/actions/#mentorat" target="_blank">
                <img className="ntjaswccliwl-image" src={ToogetherDemainLesFilles} alt="" />
              </a>
              <div className="ntjaswccliw-list-wrapper">
                <ul className="ntjaswccliwlw-list">
                  <li className="ntjaswccliwlwl-item">Le 1<sup>er</sup> programme de <a href="https://ensemble-en-stage.com/actions/#mentorat" target="_blank">mentorat féminin</a> à La&nbsp;Réunion</li>
                  <li className="ntjaswccliwlwl-item">Empouvoirer les collégiennes et lycéennes des Quartiers Prioritaires</li>
                  <li className="ntjaswccliwlwl-item">Permettre à vos collaboratrices de devenir mentores et de rayonner</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="ntjasw-coloured-card second flip-button__inner">
            {/* <div className="ntjasw-arrow">
              <i
                data-eva="arrow-forward-outline"
                data-eva-fill="#FFF"
                data-eva-height="30"
                data-eva-width="30"
              ></i>
            </div> */}
            <h3 className="ntjaswcc-title">STAGES MIXITÉ</h3>
            <p className="ntjaswcc-intro">
              En partenariat avec <a href="https://ensemble-en-stage.com/" target="_blank">Ensemble en stage</a>, l'ONG de référence pour l'égalité des chances à La Réunion
            </p>
            <div className="ntjaswcc-list-image-wrapper">
              <a href="https://ensemble-en-stage.com/actions/#stage" target="_blank">
                <img className="ntjaswccliwl-image" src={ToogetherStage} alt="" />
              </a>
              <div className="ntjaswccliw-list-wrapper">
                <ul className="ntjaswccliwlw-list">
                  <li className="ntjaswccliwlwl-item">Un <a href="https://ensemble-en-stage.com/actions/#stage" target="_blank">stage</a> unique en son genre, centré sur la mixité des métiers</li>
                  <li className="ntjaswccliwlwl-item">Offrir une journée d'immersion à un groupe de collégien-nes des Quartiers&nbsp;Prioritaires</li>
                  <li className="ntjaswccliwlwl-item">Valoriser vos équipes et vos métiers</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <h3 className="ntjas-title">Réservé aux entreprises adhérentes</h3>
        <div className="ntjas-wrapper">
          <div className="ntjasw-coloured-card first flip-button__inner">
            {/* <div className="ntjasw-arrow">
              <i
                data-eva="arrow-forward-outline"
                data-eva-fill="#FFF"
                data-eva-height="30"
                data-eva-width="30"
              ></i>
            </div> */}
            <h3 className="ntjaswcc-title">CERCLES DE PARTAGE</h3>
            <p className="ntjaswcc-intro">
              Les rencontres inter-entreprises&nbsp;: la <span className="bold">clé du succès de Toogether&nbsp;!</span>
            </p>
            <div className="ntjaswcc-list-image-wrapper">
              <HashLink to="/#adhérer" scroll={(el) => scrollWithOffset(el, 90)}>
                <img className="ntjaswccliwl-image" src={ToogetherInfinite} alt="" />
              </HashLink>
              <div className="ntjaswccliw-list-wrapper">
                <ul className="ntjaswccliwlw-list">
                  <li className="ntjaswccliwlwl-item">Résoudre les problématiques</li>
                  <li className="ntjaswccliwlwl-item">Découvrir des outils innovants</li>
                  <li className="ntjaswccliwlwl-item">Acquérir les bonnes pratiques</li>
                </ul>
              </div>
            </div>
          </div>
          <div className="ntjasw-coloured-card first flip-button__inner">
            {/* <div className="ntjasw-arrow">
              <i
                data-eva="arrow-forward-outline"
                data-eva-fill="#FFF"
                data-eva-height="30"
                data-eva-width="30"
              ></i>
            </div> */}
            <h3 className="ntjaswcc-title">FORMATIONS & CONSEIL</h3>
            <p className="ntjaswcc-intro">
              Du cousu main pour animer votre <span className="bold">Accord Égalité</span>
            </p>
            <div className="ntjaswcc-list-image-wrapper">
              <HashLink to="/#nous-contacter" scroll={(el) => scrollWithOffset(el, 120)}>
                <img className="ntjaswccliwl-image" src={ToogetherInfinite} alt="" />
              </HashLink>
              <div className="ntjaswccliw-list-wrapper">
                <ul className="ntjaswccliwlw-list">
                  <li className="ntjaswccliwlwl-item">Élaborer un diagnostic interne</li>
                  <li className="ntjaswccliwlwl-item">Conduire une enquête Harcèlement</li>
                  <li className="ntjaswccliwlwl-item">Recruter sans discriminer</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </article>
  );
};

export default NeedToJoinCpnt;
